import { Pos } from './Pos';
import { AccountsConfig } from '../model/AccountsConfig';
import { CurrencyMappings } from './CurrencyMappings';
import { CurrencyPairPriceDto } from './CurrencyPairPriceDto';
import { CurrencyTypeDto } from './CurrencyTypeDto';
import { CheckLoanMessage } from './CheckLoanMessage';

export class Wallet {
  positions: Array<Pos>;
  midPrices: CurrencyPairPriceDto;
  currencyTypes: CurrencyTypeDto;
  // tresholds: TresholdDto;
  tresholds: any;
  availableBitfinexCCYS: Array<string>;
  bitfinexLoan: CheckLoanMessage;
  currencyMappings: CurrencyMappings;
  accountsConfig: AccountsConfig;
}
